var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("LuuLocalesSimple", {
    attrs: { white: _vm.white, value: _vm.$i18n.locale },
    on: { change: _vm.changeLocale },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }